<template>
  <div class="autoRefundRecord">
    <input-form ref="form" :inputData="inputData" @toParentVal="formSearch" :btnPosition1="true"></input-form>

    <div class="table">
      <el-table
        :data="tableData"
        tooltip-effect="light"
        v-loading="loading"
        :header-cell-style="{ background: '#FAFAFA' }"
        style="width: 100%; margin-top: 18px"
      >
        <template slot="empty">
          <div>
            <img src="@/assets/images/default/暂无任何数据.png" />
            <span style="margin-left: -140px">暂无任何数据</span>
          </div>
        </template>
        <el-table-column prop="refundApplyId" label="退款单号"></el-table-column>
        <el-table-column prop="desensitizePin" label="买家账号"></el-table-column>
        <el-table-column prop="orderId" label="订单号"></el-table-column>
        <el-table-column prop="p4" label="实付金额"></el-table-column>
        <el-table-column prop="applyRefundSum" label="退款金额"></el-table-column>
        <el-table-column prop="applyTime" label="申请时间" width="170"></el-table-column>
        <el-table-column prop="checkUserName" label="审核人"></el-table-column>
        <el-table-column prop="checkTime" label="审核时间" width="170"></el-table-column>
        <el-table-column prop="isSuccess" label="审核结果">
          <template slot-scope="scope">
            <p class="state">
              <span :class="scope.row.isSuccess == '审核通过' ? 'blue' : 'red'"></span>
              {{ scope.row.isSuccess }}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :page-sizes="[10, 30, 50, 100]"
        :page-size="size"
        :current-page="current"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import inputForm from "@/components/inputForm";
import { getAuditRecord } from "@/api/serviceCenter/autoRefund";

export default {
  components: {
    inputForm,
  },
  data() {
    return {
      inputData: [
        {
          name: "订单号:",
          val: "orderId",
          placeholder: "请输入订单号",
        },
        {
          name: "审核时间:",
          myDate: true,
          val: ["auditDateTimeStart", "auditDateTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },
        {
          name: "发送状态:",
          val: "selectType",
          selectArr: [
            { label: "审核通过", id: 1 },
            { label: "审核不通过", id: 2 },
          ],
        },
      ],
      tableData: [],
      loading: false,
      // 分页配置信息
      size: 10,
      current: 1,
      total: 0,
    };
  },
  mounted() {
    this.$refs.form.submitForm("formSearch");
  },
  methods: {
    // 查询 || 获取表格数据
    formSearch(params) {
      this.loading = true;
      params.size = this.size;
      params.current = this.current;
      getAuditRecord(params).then((res) => {
        this.loading = false;
        this.total = res && +res.data.total;
        this.tableData = res && res.data.records;
      });
    },
    /**
     * 分页变化事件
     */
    handleSizeChange(val) {
      this.current = 1;
      this.size = val;
      this.$refs.form.submitForm("formSearch");
    },
    handleCurrentChange(val) {
      this.current = val;
      this.$refs.form.submitForm("formSearch");
    },
  },
};
</script>

<style scoped lang="scss">
.autoRefundRecord {
  padding: 24px 0 30px;
  .table {
    box-sizing: border-box;
    padding: 0 28px;
    .state {
      display: flex;
      align-items: center;
      margin: 10px 0;
      span {
        width: 4px;
        height: 4px;
        margin-right: 7px;
        border-radius: 50%;
      }
      .blue {
        background-color: #7f85e9;
      }
      .red {
        background-color: #fe4d45;
      }
    }
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>
